import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getBikeNoAccountList } from '../sellThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
const SLICE_NAME = 'bikeNoAccountList';

export const bikeNoAccountListSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getBikeNoAccountList });
    },
});

export const bikeNoAccountList = bikeNoAccountListSlice.reducer;
